module.exports = __webpack_public_path__ + "media/Kids.6cd3d1b9.mp3";